import {Component, inject, Injector, OnInit} from '@angular/core';
import {BasePageComponent} from '@core-components/page-content/base-page.component';
import {LandlordPropertyModel} from '@core/model/landlordProperty.model';
import {Location} from '@angular-material-extensions/google-maps-autocomplete';
import {ConsoleContextService} from "@security/console-context.service";
import {AccountSoftwareSettings, ExternalAccountSoftware} from '@features/settings/details/settings-details.model';
import {SettingsDetailsService} from '@features/settings/details/settings-details.service';
import {LoadingService} from '@ui-kit/framework/util/service/loading.service';
import PlaceResult = google.maps.places.PlaceResult;

@Component({
  selector: 'app-settings-details',
  templateUrl: './settings-details.component.html',
})
export class SettingsDetailsComponent extends BasePageComponent implements OnInit {

  externalSettings: ExternalAccountSoftware[] = [];
  private _loader = inject(LoadingService);

  currentLocation: LandlordPropertyModel | null = null;
  propertyPlace: PlaceResult | null = null;
  propertyLocation: Location | null = null;
  protected loading$ = this._loader.loading$;

  constructor(injector: Injector,
              private contextService: ConsoleContextService,
              private settingsService: SettingsDetailsService) {
    super(injector);
    this.currentLocation = this.contextService.getCurrentLocation();
  }

  ngOnInit(): void {
    this.loadExternalSettings();
  }

  loadExternalSettings(): void {
    this.settingsService.getExternalAccountingSoftwareSettings()
      .subscribe({
        next: value => {
          this.externalSettings = value;
        },
        error: err => {
          console.error(err);
        }
      });
  }

  public onAddressAutocompleteSelected(event: PlaceResult): void {
    this.propertyPlace = event;
  }

  public onAddressLocationSelected(event: Location): void {
    this.propertyLocation = event;
  }

  updateConfig(code: string, config: AccountSoftwareSettings): void {
    this.settingsService.updateConfig(code, config)
      .subscribe({
        next: value => {
          this.loadExternalSettings();
        },
        error: err => {
          console.log(err);
        }
      });
  }
}
